import axios from 'axios';
import { API_BASE_URL } from '../config';
import { authHeaders, asErr } from '../utils/apiHelpers';

// convert select values to numbers for .NET int?
const toInt = (v) => {
  if (v === undefined || v === null || v === '') return undefined;
  const n = Number(v);
  return Number.isFinite(n) ? n : undefined;
};

// ==============================
// READ overlay
// ==============================
export async function fetchEmploymentOverlay() {
  try {
    const res = await axios.get(`${API_BASE_URL}/api/employee/employment/overlay`, {
      headers: authHeaders({ 'Cache-Control': 'no-store' }),
    });
    return res.data;
  } catch (err) {
    throw asErr('Failed to fetch employment overlay', err);
  }
}

// ==============================
// WRITE draft  (FIXED TYPES)
// ==============================
export async function saveEmploymentDraft(model: any = {}) {
  const body = {
    contractual_relationship_code: model.contractual_relationship_code || undefined,  // string or undefined
    actual_job_id: toInt(model.actual_job_id),                                        // number or undefined
    position_according_to_contract_job_id: toInt(model.position_according_to_contract_job_id), // number/undef
    hiring_date: model.hiring_date || undefined,                                      // 'YYYY-MM-DD' or undefined
    has_transfer_letter:
      typeof model.has_transfer_letter === 'boolean' ? model.has_transfer_letter : undefined, // boolean/undef
  };

  // prune undefined
  Object.keys(body).forEach((k) => body[k] === undefined && delete body[k]);

  console.log('EMPLOYMENT DRAFT BODY', body, {
    types: {
        actual_job_id: typeof body.actual_job_id,
        position_job_id: typeof body.position_according_to_contract_job_id,
        has_transfer_letter: typeof body.has_transfer_letter,
    }
    });

  try {
    await axios.post(`${API_BASE_URL}/api/employee/employment/draft`, body, {
      headers: authHeaders({ 'Content-Type': 'application/json' }),
    });
  } catch (err) {
    throw asErr('Failed to save employment draft', err);
  }

  // re-read overlay after save
  return await fetchEmploymentOverlay();
}
